import { createReducer, on } from '@ngrx/store';
import { DEFAULT_PAGING } from '@shared/constants/pagination/paging.constants';
import { CombinationFilter } from '@shared/interfaces/combination/combination-filters/combination-filters.interface';
import { Paging } from '@shared/interfaces/pagination/paging.interface';
import { UserInfo } from '@shared/interfaces/user/user-info.interface';

import { setCombinationFilter, setCombinationPaging, userActions } from './user.actions';

export const userFeatureKey = 'user';

export interface UserState {
  user: UserInfo;
  loading: boolean;
  filter: CombinationFilter;
  paging: Paging;
}

export const initialState: UserState = {
  user: {
    name: '',
    admin: false,
    user: false,
    error: false
  },
  loading: true,
  filter: {} as CombinationFilter,
  paging: { ...DEFAULT_PAGING }
};

export const userReducer = createReducer<UserState>(
  initialState,
  on(userActions.loadUserDataSuccess, (state: UserState, data: { user: UserInfo }) => ({
    ...state,
    user: data.user,
    loading: false
  })),
  on(userActions.loadUserDataError, (state: UserState) => ({
    ...state,
    user: { ...state.user, error: true },
    loading: false
  })),
  on(setCombinationFilter, (state: UserState, data: { filter: CombinationFilter }) => ({
    ...state,
    filter: data.filter
  })),
  on(setCombinationPaging, (state: UserState, data: { paging: Paging }) => ({
    ...state,
    paging: data.paging
  }))
);
